$(document).ready(function () {
    $(".js-add-shadow").scroll(function () {
      var element = $(this);
      var elementParent = $(this).parent();
      var scrollLeft = element.scrollLeft();
      var totalWidth = element[0].scrollWidth - element.outerWidth();
  
      if (scrollLeft >= totalWidth) {
        elementParent.removeClass("shadow");
        console.log("Скролл уперся вправо");
      } else {
        elementParent.addClass("shadow");
      }
    });
  });
  